<template>
  <transition name="modal">
    <div class="modal-mask" @click="close">
      <div class="modal-wrapper">
        <div class="modal modal-container" :class="dialogStyle" @click.stop="">

          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: {
    'dialogStyle': String
  },
  emits: ['close'],
  setup (props, {emit}) {
    const close = (() => {
      emit('close')
    })
    return {
      close
    }
  }
}
</script>
